<template>
     <Modal
        title="Choose location"
        class="modal-primary"
        v-model="modalView"
        @on-ok="$emit('modalLocation')"
        @on-cancel="$emit('modalLocation')"
        @headerclose="$emit('modalLocation')"
        @close="$emit('modalLocation')"
        :transfer="false"
      >
        <b-form-input
            style="display:inline-block; width:250px;"
            v-model="searchQuery"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>

          <hr />
          <div style="height: 400px; padding-top: 150px" v-if="!dataReady" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-row v-else style="padding:2em;">
            <template v-for="location in filterItems(locations)">
              <b-col lg="4" sm="6" :key="location.id" style="padding: 5px;">
                <a
                  class="locationLabels"
                  style="font-size:1.2em;"
                  :href="'#/base/city/?loc=' + location.id + '&city=' + location.location + '&lat=' + location.lat + '&lng=' + location.lng"
                  v-b-tooltip.hover
                  :title="location.id + ' - ' + location.contact"
                >{{location.location }} ({{location.backlog}})</a>
              </b-col>
            </template>
          </b-row>
         
      </Modal>
</template>

<script>
export default {
  props: ["modal"],
   data: function() {
    return {
        modalView: true,
        dataReady: false,
        locations: [],
        searchQuery: ""
    }
   },
   methods: {
    fetchLocation() {
        this.$http
        .get("api/charts/locationsBacklogCount.php").then(
          res => { 
            console.log(res.data)
            const parsedData = res.data;
            this.locations = parsedData;
            console.log(this.locations);
            this.dataReady = true;
          },
          err => {
            console.log(err);
          });
    },
    filterItems: function(locations) {
      var app = this;
      return locations.filter(function(location) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return location.location.match(regex);
      });
    }
   },
   mounted() {
       this.fetchLocation();
   }
}
</script>